export type CaseFileDisplayLabelInput = {
  details?: string | null;
  documentName?: string | null;
};

export function getCaseFileDisplayLabel(file: CaseFileDisplayLabelInput | null | undefined, fallback = ''): string {
  const details = file?.details?.trim();
  if (details) return details;
  return file?.documentName?.trim() || fallback;
}
